import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[spxDialog]',
})
export class DialogDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
